import {Component, Host, h, Prop, Element} from '@stencil/core';
import { setCookie } from '../../utils/cookie';

@Component({
  tag: 'bam-back-teaser-content',
  shadow: false,
})
export class BamBackTeaserContent {
  @Element() el: HTMLElement
  /**
   * Defines the type of the insurance
   */
  @Prop() type: string = ''
  /**
   * Defines the expiration days of the cookie
   */
  @Prop() cookieExpire: number = 30

  handleClose = () => {
    const backTeaser = this.el.closest('bam-back-teaser')
    const backTeaserList = this.el.closest('bam-back-teaser-list')
    setCookie(`notification-back-${this.type}-`,'true',this.cookieExpire)
    backTeaser.value = false
    backTeaser.active = false
    backTeaserList.restart = true
  }

  render() {
    return (
      <Host>
        <bal-card space="medium">
          <div class="back-teaser__card-inner-wrapper mx-normal">
            <div class="flex justify-content-end">
              <bal-close onClick={this.handleClose} size=""></bal-close>
            </div>
            <div class="back-teaser__card-inner-content" data-js-item="back-teaser-content-wrapper">
              <slot name="icon"></slot>
              <slot name="headline"></slot>
              <slot name="text"></slot>
              <slot name="buttons"></slot>
              <slot name="next"></slot>
            </div>
          </div>
        </bal-card>
        <slot></slot>
      </Host>
    );
  }

}
